import React, { useEffect, useState } from "react";
import CardSection from "../../../../../../../components/ui/card/CardSection";
import "./SynergyTasks.scss";
import Image from "../../../../../../../components/image/Image";
import Avatar from "../../../../../../../components/ui/avatar/Avtar";
import { useLazyGetSynergyTaskBySynergyIdQuery, useRemoveSynergyTaskByTaskIdMutation } from "../../../../../../../app/services/projectSynergyAPI";
import NoRecordFound from "../../../../../../../components/FinalMolGrid/ui/noRecordFound/NoRecordFound";
import { encryptUrlData } from "../../../../../../../services/CryptoService";
import { AppIcons } from "../../../../../../../data/appIcons";
import Iconify from "../../../../../../../layouts/components/iconify/iconify";
import ToastService from "../../../../../../../services/toastService/ToastService";
import SwalAlert from "../../../../../../../services/swalService/SwalService";

const SynergyTasks = ({ synergyId}) => {
  const [tasks, settasks] = useState([]);
  const { confirm } = SwalAlert();

  // API Calls
  const [
    getSynergyTaskBySynergyId,
    {
      isFetching: isgetSynergyTaskBySynergyIdFetching,
      isSuccess: isgetSynergyTaskBySynergyIdSuccess,
      data: getSynergyTaskBySynergyIdData,
    },
  ] = useLazyGetSynergyTaskBySynergyIdQuery();

  const [removeSynergyTaskByTaskId, {
    isSuccess: isRemoverSuccess,
    data: RemoveSynergyData,
  },] = useRemoveSynergyTaskByTaskIdMutation();

  useEffect(() => {
    if (
      !isgetSynergyTaskBySynergyIdFetching &&
      isgetSynergyTaskBySynergyIdSuccess &&
      getSynergyTaskBySynergyIdData
    ) {
      settasks(getSynergyTaskBySynergyIdData);
    }
  }, [
    isgetSynergyTaskBySynergyIdFetching,
    isgetSynergyTaskBySynergyIdSuccess,
    getSynergyTaskBySynergyIdData,
  ]);

  useEffect(() => {
    if (synergyId) {
      getSynergyTaskBySynergyId(synergyId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [synergyId]);

  useEffect(() => {
    if (isRemoverSuccess && RemoveSynergyData) {
      ToastService.success(RemoveSynergyData.errorMessage);
      getSynergyTaskBySynergyId(synergyId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRemoverSuccess && RemoveSynergyData]);

  const onDeleteAction = (taskId) => {
         confirm(
        "Remove?",
        "Are you sure you want to Remove?",
        "Remove",
        "Cancel"
      ).then((confirmed) => {
        if (confirmed) {
           removeSynergyTaskByTaskId(taskId.taskId);;
        }
      });
  };

  const handleClick = (data) => {
    const dataURL = {};
    dataURL.taskId = data.taskId;
    dataURL.projectId = data.projectId;
    window.open(`/project/EditTask/${encryptUrlData(dataURL)}}`, "_blank");
  };

  const totalEstHours = tasks.reduce((total, task) => {
    const estimateHours = task.estimateHours || 0;
    return total + estimateHours;
  }, 0);

  const totalActualHours = tasks.reduce((total, task) => {
    const ActualHours = task.actualHours || 0;
    return total + ActualHours;
  }, 0);

  const RemainingHours = (totalEstHours) - (totalActualHours);

  return (
    <div className="synergy-tasks">
      <CardSection cardTitle="Synergy Action Tasks">
        <div className="group-key-header synergy-action-tasks">
          <div className="group-key-body hours">
            <div className="group-key-bodyitem">
              <Iconify icon="ri:timer-line" />
              Est.: {totalEstHours}
            </div>
            <div className="group-key-bodyitem">
              <Iconify icon="ri:timer-line" />
              Act.: {totalActualHours}
            </div>
            <div className="group-key-bodyitem">
              <Iconify icon="ri:timer-line" />
              Rem.: {RemainingHours}
            </div>
          </div>
        </div>
        <table className="backlog-table">
          <thead>
            <tr>
              <th className="task-id">Task Type/ID</th>
              <th className="comments-header">Task Name</th>
              <th className="left-count">Est.</th>
              <th className="left-count">Act.</th>
              <th className="priority-count">Assign</th>
              <th className="priority-count">Remove</th>
            </tr>
          </thead>
          <tbody>
            {tasks.length > 0 ? (
              tasks.map((task) => (
                <tr key={task.id}>
                  <td className="task-id">
                    <div className="task-id-icon">
                      <Image
                        imagePath={
                          task.taskTypeName === "Task"
                            ? AppIcons.Task
                            : task.taskTypeName === "Bug"
                              ? AppIcons.Bug
                              : null
                        }
                        altText="Vector Image"
                      />
                      <span />
                      <span
                        onClick={() =>
                          handleClick({
                            taskId: task.taskId,
                            projectId: task.projectId,
                          })
                        }
                      >
                        {task.projectTaskTitle}
                      </span>
                    </div>
                  </td>
                  <td className="task-name">{task.title}</td>
                  <td className="task-estimation">{Number(task.estimateHours).toFixed(2) || "0.00"}</td>
                  <td className="task-estimation">{Number(task?.actualHours).toFixed(2) || "0.00"}</td>
                  <td className="task-assignee">
                    <div className="task-avatar">
                      <Avatar
                        src=""
                        alt={task.assigneeName}
                        size="small"
                        shape="circle"
                      />
                    </div>
                  </td>
                  <td className="task-assignee text-center">
                       <Iconify icon="iwwa:delete" onClick={() => onDeleteAction({taskId: task.taskId})}/>
                  </td>
                </tr>
              ))
            ) : (
              <div className="no-data-found">
                <NoRecordFound message="No Task Available" />
              </div>
            )}
          </tbody>
        </table>
      </CardSection>
    </div>
  );
};

export default SynergyTasks;
